import { Injectable } from '@angular/core';
import { StorageBase } from './class/storage';

export { PreferredSettings } from './class/storage';

/** 
 * Wrapper for all stored values, determining where they are stored
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService extends StorageBase{}

